import { render, staticRenderFns } from "./RegLeishmaniasiEdit.vue?vue&type=template&id=4b6d30c4"
import script from "./RegLeishmaniasiEdit.vue?vue&type=script&lang=js"
export * from "./RegLeishmaniasiEdit.vue?vue&type=script&lang=js"
import style0 from "./RegLeishmaniasiEdit.vue?vue&type=style&index=0&id=4b6d30c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports